/* panel-title.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1k8s%7Bheight%3A1.5rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1k8s%7Bwidth%3A1.5rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1b66%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
import type { ReactNode } from 'react';
import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives/compiled';
export interface PanelTitleProps {
  /**
   * The title text content.
   */
  children: ReactNode;
  /**
   * Optional icon to display alongside the title.
   */
  icon?: ReactNode;
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
}
const styles = {
  title: "_1e0c1txw _4cvr1h6o _16jlkb7n",
  titleText: "_bozg1b66",
  icon: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s"
};

/**
 * The PanelTitle component provides a standardized title display for panels
 * with optional icon support and consistent typography.
 */
export function PanelTitle({
  children,
  icon,
  testId
}: PanelTitleProps): JSX.Element {
  return <Box testId={testId} xcss={styles.title}>
			{icon && <Box xcss={styles.icon}>{icon}</Box>}
			<span className={ax([styles.titleText])}>
				<Heading size="small" as="h2">
					{children}
				</Heading>
			</span>
		</Box>;
}